import { COMPANY, CONNECTION, apiUrl } from './config.js';
import { logService } from './logs.js';
export function unwrap(value) {
  let result = value;
  for (let index = 0; index < 8; index++) {
    if (result?.Exito === false) throw new Error(result.MensajeError || 'El servidor rechazó la operación.');
    if (result && typeof result === 'object' && 'Rpta' in result) { result = result.Rpta; continue; }
    if (typeof result === 'string' && /^[\[{]/.test(result.trim())) {
      try { result = JSON.parse(result); continue; } catch { /* CSV */ }
    }
    break;
  }
  if (result?.success === false) throw new Error(result.mensaje || 'El servidor rechazó la operación.');
  return result;
}
export async function request(path, body, options = {}) {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), options.timeout || 20000);
  try {
    const response = await fetch(apiUrl(path), {
      method: body === undefined ? 'GET' : 'POST', ...options,
      headers: { Accept: 'application/json', 'Content-Type': 'application/json', ...options.headers },
      body: body === undefined ? undefined : JSON.stringify(body), signal: controller.signal
    });
    const raw = await response.text();
    let data;
    try { data = JSON.parse(raw); } catch { throw new Error(`Respuesta inválida del servicio (HTTP ${response.status}).`); }
    if (!response.ok || data?.Exito === false) {
      const error = new Error(data?.MensajeError || data?.Mensaje || `El servicio respondió HTTP ${response.status}.`);
      error.confirmedRejection = response.ok && data?.Exito === false;
      throw error;
    }
    return data;
  } catch (error) {
    logService(path.split('?')[0], error.message);
    if (error.name === 'AbortError') throw new Error('Se agotó el tiempo de espera. Comprueba la operación antes de repetirla.');
    throw error;
  } finally { clearTimeout(timeout); }
}
export async function vendey(procedure, parameters) {
  return unwrap(await request('Vendey/EjecutarVendey', { token: COMPANY, procedure, parametros: parameters }));
}
export async function execute(procedure, observations) {
  return unwrap(await request('whatsgoinon/Ejecutarv2', {
    ...CONNECTION, CPROCEDURE: procedure, COBSERVACIONES: typeof observations === 'string' ? observations : JSON.stringify(observations)
  }));
}
export function csvRows(value) {
  if (Array.isArray(value)) return value;
  if (Array.isArray(value?.resultado)) return value.resultado;
  if (typeof value !== 'string' || !value.trim()) return [];
  const [header, ...lines] = value.split('¬');
  const keys = header.split('|').map(key => key.trim());
  return lines.filter(line => line.trim()).map(line => Object.fromEntries(line.split('|').map((item, i) => [keys[i] || String(i), item.trim()])));
}
export function combo(value) {
  const seen = new Set();
  return csvRows(value).map(row => {
    const values = Object.values(row);
    return { id: String(row.ncodigo ?? row.NCODIGO ?? values[0] ?? ''), name: String(row.cdescripcion ?? row.CDESCRIPCION ?? values[1] ?? '') };
  }).filter(row => row.id && row.name && !seen.has(row.id) && seen.add(row.id));
}
export async function searchStock({ query = '', warehouseId, priceListId = 1 }) {
  return csvRows(await execute('spINVPRODUCTOSTOCKCSVWEBV2', { CBUSQUEDA: query.trim(), NCODALMACEN: Number(warehouseId), NCODLISTAPRECIO: Number(priceListId) || 1 }));
}
export async function validateStock(productId, session) {
  const result = unwrap(await request('ValidarStock', { token: COMPANY, NCODPERIODO: Number(localStorage.getItem('vendeyInventarioPeriodo')) || 188, NCODALMACEN: Number(session.warehouseId), NCODPRODUCTO: Number(productId) }));
  if (!result || typeof result !== 'object') throw new Error('No se pudo validar el stock.');
  const stock = Number(result.NSTOCKACTUAL_PRESENTACION ?? result.NSTOCKACTUAL_KILOS ?? result.NSTOCKACTUAL);
  const controlled = ['1', 'true', 'si', 'sí'].includes(String(result.NVALIDARSTOCK ?? result.VALIDARSTOCK ?? 1).toLowerCase());
  if (controlled && !Number.isFinite(stock)) throw new Error('El servicio no devolvió un stock válido.');
  return { stock, controlled, baseId: String(result.NCODPRODUCTO_BASE ?? productId), factor: Number(result.FACTOR_CONVERSION ?? 1), baseStock: Number(result.NSTOCKACTUAL_KILOS ?? result.NSTOCKACTUAL) };
}
export async function getKardex({ periodId, warehouseId, productId = 0, from, to }) {
  const result = await execute('spINVKARDEXPRODUCTOSWEB', { NCODPERIODO: Number(periodId), NCODALMACEN: Number(warehouseId), NCODPRODUCTO: Number(productId) || 0, DDESDE: from, DHASTA: to });
  if (!result || typeof result !== 'object') throw new Error('El Kardex no devolvió información válida.');
  return { summary: result.resumen || [], equivalents: result.equivalencias || [], movements: result.kardex || [] };
}
export async function downloadStock({ warehouseId, productId = 0, onlyAvailable = false, to = '' }) {
  const data = unwrap(await request('vendey/descargaxlsxreport', { token: COMPANY, ncodempresa: 1, ncodalmacen: Number(warehouseId), soloconexistencia: Boolean(onlyAvailable), ...(Number(productId) > 0 ? { ncodproducto: Number(productId) } : {}), ...(to ? { dhasta: to } : {}) }));
  const raw = String(data ?? '').replace(/^['"]|['"]$/g, '');
  const url = raw.startsWith('/Files/') ? apiUrl(raw) : raw;
  if (!/^https:\/\//i.test(url)) throw new Error('El servidor no devolvió una descarga válida.');
  const anchor = document.createElement('a'); anchor.href = url; anchor.target = '_blank'; anchor.rel = 'noopener'; anchor.click();
}
export async function lookupCustomer(document, type) { return unwrap(await request('Vendey/ConsultaRucDniV2', { token: COMPANY, CNUMDOCCLIENTE: document, CCODDOCCLIENTE: type })); }
export async function findBarcode(code) { return unwrap(await request('Vendey/BuscarCodBar?' + new URLSearchParams({ codbar: code, ncodempresa: '1', Token: COMPANY }), {})); }
export function pipe(values) {
  if (values.some(value => /[|¬]/.test(String(value)))) throw new Error('Los datos no pueden contener | o ¬.');
  return values.join('|');
}
